const addHoliday = (context, dayName, newDay) => {
  context.commit("ADD_HOLIDAY", dayName, newDay);
};

const removeHoliday = (context, dayKey) => {
  context.commit("REMOVE_HOLIDAY", dayKey);
};

const addException = (context, newDay) => {
  context.commit("ADD_EXCEPTION", newDay);
};

const removeException = (context, dayKey) => {
  context.commit("REMOVE_EXCEPTION", dayKey);
};

export default {
  addHoliday,
  removeHoliday,
  addException,
  removeException,
};
